export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="hidden md:block pt-[clamp(6px,1.5vw,16px)] pb-[clamp(4px,1vw,12px)] px-[clamp(12px,3vw,16px)] border-t border-border bg-surface">
      <div className="max-w-[1200px] mx-auto">
        {/* Desktop: single row | Mobile: stacked */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-[clamp(4px,1vw,8px)] md:gap-0">
          {/* Copyright */}
          <span className="text-[clamp(10px,2.5vw,14px)] text-muted-foreground">
            © {currentYear} Imagine Sports
          </span>

          {/* Divider - desktop only */}
          <span className="hidden md:inline text-[clamp(10px,2.5vw,14px)] text-muted-foreground mx-3">|</span>

          {/* Links - TODO: Update hrefs when legal pages are created */}
          <div className="flex items-center gap-[clamp(8px,2vw,12px)]">
            <a
              href="#" // TODO: Update to "/terms" when route is created
              className="text-[clamp(10px,2.5vw,14px)] text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </a>
            <span className="text-[clamp(10px,2.5vw,14px)] text-muted-foreground">|</span>
            <a
              href="#" // TODO: Update to "/privacy" when route is created
              className="text-[clamp(10px,2.5vw,14px)] text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
